const Fetcher = require('od-modules/utils/fetcher');
const {loadGoogleMaps} = require('od-modules/helpers/map/googleMapsLoader');
const trackingUtils = require('../utils/tracking.utils');
const REST = {
    MARKERS: 'accommodation/google-dynamic-map',
    DETAILS: 'accommodation/details',
};

module.exports = Odigeo.Model.extend({
    dataUrl: '',

    setUrl: function(url) {
        this.dataUrl = url;
    },

    init: function() {
        this.widget.options = Odigeo.Utils.parseOptions(this.widget.options);
        this.publishMarkers([]);
    },

    url: function() {
        return Odigeo.Settings.getProperty('serviceUrlFormatter')(this.dataUrl);
    },

    update: function() {
        const initTime = new Date();

        this.setUrl(`${REST.MARKERS}/${Odigeo.History.getPageNameFromFragment()}/marker-list`);
        return this.clear().fetch({
            success: () => {
                this.updateMapView();
                if (this.widget.options.isActiveGraphanaTracking) {
                    trackingUtils.trackTimeMetric(this.widget.options.grafanaTrackingMapKey, initTime);
                }
            },
            error: () => {
                this.publishMarkers([]);
                if (this.widget.options.isActiveGraphanaTracking) {
                    trackingUtils.counterMetric(this.widget.options.grafanaTrackingOnErrorKey);
                }
            },
        });
    },

    updateDetails: function(key) {
        this.setUrl(REST.DETAILS);
        return Fetcher.get(`${this.url()}?key=${key}`).json();
    },

    updateMapView: function() {
        loadGoogleMaps().then(() => this.trigger('update_map'));
    },

    publishMarkers: function(markers) {
        Odigeo.trigger(this.widget.id + ':loadMarkers', markers);
    },
});
